import React, { useContext, useRef, useState } from "react";
import axios from "axios";
import ProgressBar from "./ProgressBar";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import Label from "../ui-components/Label";
import { PlusIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { NotificationsContext } from "../ui-components/Notifications";
import { useParams } from "react-router-dom";
import CountryContext from "../CountryContext";
import { useIntl } from "react-intl";

const re = /(?:\.([^.]+))?$/;

const ServiceConfiguratorOpenBlockImage = ({
  onChange,
  maxSize = 2048,
  newData,
  editable = true,
}) => {
  const { serviceId } = useParams();
  const { country } = useContext(CountryContext);

  const ref = useRef();
  const [progress, setProgress] = useState(0);
  const apiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);

  const intl = useIntl();

  return (
    <div className="flex w-full flex-col">
      <Label>Image</Label>
      <div>
        <input
          accept="image/jpeg,image/png"
          ref={ref}
          type="file"
          style={{ display: "none" }}
          onChange={async (e) => {
            const file = e.target.files[0];
            e.target.value = null;

            const format = re.exec(file.name)[1];

            if (!format) {
              push({
                title: "Unknown file format",
                type: "error",
              });
              return;
            }

            if (maxSize) {
              const size = file.size;
              const kb = Math.round(size / 1024);

              if (maxSize < kb) {
                push({
                  title: "File size too big",
                  type: "error",
                });
                return;
              }
            }

            const { url, fields } = await apiRequest.post(`/aws-signed-url`, {
              content_type: file.type,
              format: format,
              prefix: `images/${country.code}/service/${serviceId}`,
              bucket: "configurator_images",
              method: "POST",
            });

            const formData = new FormData();
            Object.keys(fields).map((key) => {
              return formData.append(key, fields[key]);
            });
            // Actual file has to be appended last.
            formData.append("file", file);

            const options = {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "*",
                "Cache-Control": "max-age=31536000",
              },
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.floor(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setProgress(percentCompleted);
              },
            };

            try {
              await axios.post(url, formData, options);
              setProgress(0);
              onChange(fields.key);
            } catch (error) {
              console.log(error);
              setProgress(0);
              push({
                title: "Something went wrong",
                type: "error",
              });
            }
          }}
        />
        {newData.image_filename ? (
          <div
            className={
              editable?
            "relative cursor-pointer mt-2 mb-4 w-40 h-40 flex items-center justify-center border-4"
            :
            "relative cursor-not-allowed mt-2 mb-4 w-40 h-40 flex items-center justify-center border-4 bg-gray-200"
            }>
            {newData.image_filename ? (
              <div
                className="w-full h-full bg-cover bg-center relative"
                style={{
                  backgroundImage: `url(${"/" + newData.image_filename})`,
                }}
              >
                {editable && <div
                  onClick={() => {
                    onChange("");
                  }}
                  className="cursor-pointer text-red-400 absolute w-6 h-6 -right-3 -bottom-3"
                >
                  <XCircleIcon />
                </div>}
              </div>
            ) : null}
          </div>
        ) : (
          <div
            className={
            editable?
            "relative p-4 cursor-pointer mt-2 mb-4 w-40 h-40 flex items-center justify-center border-4"
            :
            "relative p-4 cursor-not-allowed mt-2 mb-4 w-40 h-40 flex items-center justify-center border-4 bg-gra y"
            }
            onClick={(e) => {
              e.preventDefault();
              if (editable)
                ref.current.click();
            }}
          >
            {progress ? (
              <ProgressBar progress={progress} />
            ) : (
              <div className="w-10 h-10 text-gray-300">
                {
                  editable ?
                  <PlusIcon/> :
                    <div className={"justify-center items-center flex flex-col"}>
                      <span>
                        {intl.formatMessage({id: "no_image", defaultMessage: "Nessuna immagine selezionata"})}
                      </span>
                    </div>
                }
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceConfiguratorOpenBlockImage;
